import { VpIcon } from '@vtmn-play/react'
import { VpIconName } from '@vtmn-play/icons'
import { useTranslation } from 'react-i18next'
import WidgetErrorCard from 'components/common/cards/widget-error-card'

type IconBackground = 'blue' | 'purple' | 'yellow' | 'sky'
type DeltaVariant = 'positive' | 'negative'

type LastFourWeeksStorePerformanceCardProps = {
  icon: VpIconName
  titleKey: string
  value: string
  delta: string
  deltaVariant: DeltaVariant
  iconBackground?: IconBackground
}

const LastFourWeeksStorePerformanceCard = ({
  icon,
  titleKey,
  value,
  delta,
  deltaVariant,
  iconBackground = 'blue'
}: LastFourWeeksStorePerformanceCardProps) => {
  const { t } = useTranslation()
  if (!value) {
    return <WidgetErrorCard titleKey={titleKey} />
  }

  return (
    <div className="mg-last-four-weeks-store-performance-card">
      <div
        className={`mg-last-four-weeks-store-performance-card-icon mg-last-four-weeks-store-performance-card-icon--${iconBackground}`}
      >
        <VpIcon {...({ name: icon, size: 16 } as any)} />
      </div>
      <div className="mg-last-four-weeks-store-performance-card-body">
        <div className="vp-caption mg-last-four-weeks-store-performance-card-label">{t(titleKey)}</div>
        <div className="mg-last-four-weeks-store-performance-card-value-row">
          <div className="vp-subtitle-m mg-last-four-weeks-store-performance-card-value">{value}</div>
          {delta && (
            <div
              className={`vp-caption mg-last-four-weeks-store-performance-card-delta mg-last-four-weeks-store-performance-card-delta--${deltaVariant}`}
            >
              {delta}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LastFourWeeksStorePerformanceCard
